module.exports = __webpack_public_path__ + "static/img/ry3.c98844dd.png";